export const CAROUSEL_CONTENT = {
  NAKED_NEWS: {
    heading1: 'Welcome to',
    heading2: 'Naked News',
    content: 'Hottest News Show on the Planet',
    color: '#ffffff',
    uppercase: true,
    ctaLink: '/account/purchase?tour_video=general',
  },
  NAKED_NEWS_LIVE: {
    heading1: 'Naked News',
    heading2: 'Live',
    content:
      'Interact with the world\'s sexiest adult content creators',
    color: '#ffffff',
    uppercase: true,
    ctaLink: '/account/purchase?tour_video=naked news live',
  },
  AUDITIONS: {
    heading1: 'Naked News',
    heading2: 'Auditions',
    content: 'Hundreds of amateur auditions',
    color: '#ffffff',
    uppercase: true,
    ctaLink: '/account/purchase?tour_video=audition',
  },
};
